import { render, staticRenderFns } from "./ConfigPage.vue?vue&type=template&id=403aa924&scoped=true&"
import script from "./ConfigPage.vue?vue&type=script&lang=js&"
export * from "./ConfigPage.vue?vue&type=script&lang=js&"
import style0 from "./ConfigPage.vue?vue&type=style&index=0&id=403aa924&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403aa924",
  null
  
)

export default component.exports